import { useEffect, useContext } from 'react';
import PropTypes, { InferProps } from 'prop-types';
import { useRouter } from 'next/router';
import { UserContext } from './UserProvider';
import { useSiteContext } from './SiteContext';

const plausiblePropertiesPropertyTypes = {
  author: PropTypes.string,
  id: PropTypes.number,
  insertedAt: PropTypes.string,
  featured: PropTypes.bool,
  pressRelease: PropTypes.bool,
  partnerContent: PropTypes.bool,
  category: PropTypes.shape({
    title: PropTypes.string,
  }),
};

type IPlausibleProperties = InferProps<typeof plausiblePropertiesPropertyTypes>;

const PlausibleProperties = ({
  author,
  id,
  insertedAt,
  featured,
  pressRelease,
  partnerContent,
  category,
}: IPlausibleProperties) => {
  const { title: categoryTitle } = category ?? {};
  const { route, query } = useRouter();
  const { user, loading } = useContext(UserContext);
  const { locale } = useSiteContext();

  useEffect(() => {
    if (!loading) {
      const isLoggedIn = user !== null;

      window.plausible('pageview', {
        props: {
          author,
          id,
          insertedAt,
          featured,
          pressRelease,
          partnerContent,
          categoryTitle,
          isLoggedIn,
          locale,
        },
      });
    }
  }, [
    loading,
    user,
    author,
    id,
    insertedAt,
    featured,
    pressRelease,
    partnerContent,
    categoryTitle,
    route,
    query,
    locale,
  ]);

  return null;
};

export default PlausibleProperties;
